import { PayslipTypeEnum } from 'features/Enterprise/Payroll/types'

export type PayslipModalType = PayslipTypeEnum.REGULAR | PayslipTypeEnum.INCENTIVE

export const PAYSLIP_MODAL_LABELS: Record<
  PayslipModalType,
  {
    editModalTitle: string
    payslipNewTitle: string
    confirmMessage: string
    section1Label: string
    addSection1Label: string
    addIncomeModalTitle: string
    payslipNewSection1Label: string
    payslipNewSection2Label: string
    showIncomeBlock: boolean
  }
> = {
  [PayslipTypeEnum.REGULAR]: {
    editModalTitle: 'Edit Regular Payslip',
    payslipNewTitle: 'Regular Payslip Baru',
    confirmMessage: 'Yakin untuk edit reguler payslip ?',
    section1Label: 'Pendapatan Lainnya',
    addSection1Label: 'Tambah Pendapatan Lainnya',
    addIncomeModalTitle: 'Tambah Pendapatan Lainnya',
    payslipNewSection1Label: 'Pendapatan',
    payslipNewSection2Label: 'Pendapatan Lainnya',
    showIncomeBlock: true,
  },
  [PayslipTypeEnum.INCENTIVE]: {
    editModalTitle: 'Edit Incentive Payslip',
    payslipNewTitle: 'Incentive Payslip Baru',
    confirmMessage: 'Yakin untuk edit incentive payslip ?',
    section1Label: 'Incentive',
    addSection1Label: 'Tambah Incentive',
    addIncomeModalTitle: 'Tambah Incentive',
    payslipNewSection1Label: 'Incentive',
    payslipNewSection2Label: 'Potongan',
    showIncomeBlock: false,
  },
}
